
export const scrollToTop = () => {

    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });


    setTimeout(() => {

        if (window.pageYOffset > 0) {
            window.scrollTo(0, 0);
        }
    }, 100);
};


export const scrollToSection = (target, headerOffset = 80) => {

    const cleanTarget = target.replace(/^\/?#/, '#');


    if (!cleanTarget.startsWith('#')) {
        scrollToTop();
        return true;
    }


    const element = document.querySelector(cleanTarget);
    if (!element) {
        console.log(`Element not found: ${cleanTarget}`);
        return false;
    }


    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;


    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });

    return true;
};


export const initSmoothScrolling = () => {

    if (window.location.hash) {

        setTimeout(() => {
            scrollToSection(window.location.hash);
        }, 500);
    } else {

        scrollToTop();
    }

    window.addEventListener('hashchange', () => {
        if (window.location.hash) {
            setTimeout(() => scrollToSection(window.location.hash), 100);
        } else {
            scrollToTop();
        }
    });
};